// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__yl4Wy","notification":"banner_notification__rQnMI"};